import { call, put, takeLatest } from 'redux-saga/effects'
import { IBindingsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import * as actions from '../store/options.actions'
import { GlobalDataConstants } from '../../globalData/store/globalData.constants'
import { GlobalOptionsService } from '../services/globalOptions.service'
import { safeJsonParse } from '../../../utilities/safeParse.util'

export function* setFillablePDFBindingOptions() {
  const globalOptionsService = new GlobalOptionsService()
  try {
    const response: IBindingsResponse = yield call([globalOptionsService, globalOptionsService.getFillablePDFBindings])
    const { js } = response
    const parsedJS = safeJsonParse(js)
    yield put(actions.setFillablePDFBindings(parsedJS.entity ?? []))
  } catch (e) {
    yield put(throwPcrException(`setFillablePDFBindingOptions() error: ${e}`))
  }
}
export function* setFillablePDFBindingOptionsSaga() {
  yield takeLatest([GlobalDataConstants.ON_GLOBAL_DATA_IMPORT_SUCCESS], setFillablePDFBindingOptions)
}
